// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ItemDetails_wrapper__1N6_E","detailTable":"ItemDetails_detailTable__1fDUN"};